module.exports = __webpack_public_path__ + "static/img/No3.72832317.png";